import type { TeamsFilterKey } from '@/lib/api/types/itemFilters';

export const TEAMS_PICKLIST_FILTERS = [
  'roleId',
  'loopId',
] as const satisfies readonly TeamsFilterKey[];

export const getTeamsTableFilters = () => [...TEAMS_PICKLIST_FILTERS] as const;
